<template>
  <v-container fluid>
    <h1 class="d-sr-only">Beiträge & Gebühren – SC Budokwai Garbsen e.V.</h1>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Mitgliedsbeiträge </v-card-title>
          <v-card-subtitle>
            Die Monatsbeiträge werden quartalsweise per Lastschrift jeweils zu
            Beginn des zweiten Monats des jeweiligen Quartals eingezogen. Eine
            Abrechnung über BuT ist möglich. Kündigungen können mit einer Frist
            von einem Monat zum Quartalsende erfolgen.
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              :headers="beitrag_header"
              :items="beitrag"
              :items-per-page="5"
              disable-sort
              hide-default-footer
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Gebühren </v-card-title>
          <v-card-subtitle>
            Der Jahresbeitrag des Niedersächsischen Judo Verbandes (NJV) und des
            Deutschen Judo Bundes (DJB) wird im ersten Quartal des Jahres
            zusammen mit den Monatsbeiträgen abgebucht. Als Nachweis
            (Voraussetzung zur Teilnahme an Prüfungen und Wettkämpfen) bekommt
            jedes Mitglied Anfang des Jahres eine Jahressichtmarke.
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              :headers="gebuhren_header"
              :items="gebuhren"
              :items-per-page="5"
              disable-sort
              hide-default-footer
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BeitrageUGebuhren",
  data() {
    return {
      beitrag_header: [
        { value: "model", text: "" },
        { value: "behinderte", text: "Menschen mit Behinderung" },
        { value: "jugendliche", text: "Jugendliche" },
        { value: "Erwachsene", text: "Erwachsene" },
        { value: "familien", text: "Familien" },
      ],
      beitrag: [
        {
          model: "Monatsbeitrag",
          behinderte: "6,50€",
          jugendliche: "6,50€",
          Erwachsene: "10,50€",
          familien: "21€",
        },
        {
          model: "Aufnahmegebühr (einmalig)",
          behinderte: "10€",
          jugendliche: "20€",
          Erwachsene: "30€",
          familien: "60€",
        },
      ],

      gebuhren_header: [
        { value: "produkt", text: "" },
        //{'value': "bemerkung", 'text': "Bemerkung"},
        { value: "falligkeit", text: "Fälligkeit" },
        { value: "betrag", text: "Betrag" },
      ],
      gebuhren: [
        {
          produkt: "Digitaler Judopass",
          bemerkung: "",
          falligkeit: "einmalig bei Aufnahme",
          betrag: "16€",
        },
        {
          produkt: "Jahressichtmarke",
          bemerkung: "",
          falligkeit: "jährlich (im Februar oder bei Aufnahme)",
          betrag: "26€",
        },
        {
          produkt: "Prüfungsgebühren inkl. Urkunde",
          bemerkung: "",
          falligkeit: "bei Prüfung",
          betrag: "15€",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
